/**
 * Qui appelle-t-on ? Une fiche peut porter un standard et plusieurs contacts
 * joignables : au clic sur « Appeler » (ou depuis « Préparer mon appel »), on
 * choisit la personne, et l'appel part avec son identifiant — la conversation
 * est alors rattachée au bon interlocuteur.
 */
import { PhoneCall, Building2, UserRound, X } from "lucide-react";
import Modal from "@/crm/components/Modal";

/** Numéros joignables de la fiche : standard(s) puis contacts avec téléphone. */
export function callTargets(company) {
  const out = [];
  if (company?.telephone) out.push({ key: "standard", number: company.telephone, label: "Standard", sub: company.nom, contact_id: null });
  if (company?.telephone_secondaire && company.telephone_secondaire !== company.telephone) {
    out.push({ key: "standard2", number: company.telephone_secondaire, label: "Ligne secondaire", sub: company.nom, contact_id: null });
  }
  for (const ct of company?.contacts || []) {
    if (!ct.telephone) continue;
    out.push({ key: ct.id, number: ct.telephone, label: [ct.prenom, ct.nom].filter(Boolean).join(" ") || "Contact",
               sub: ct.fonction || "", contact_id: ct.id });
  }
  return out;
}

export const needsChoice = (company) => callTargets(company).length > 1;

export default function ContactPicker({ company, title = "Qui appeler ?", onPick, onClose }) {
  const targets = callTargets(company);
  return (
    <Modal onClose={onClose} testid="contact-picker" label={title} className="max-w-md">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-slate-900">{title}</h3>
        <button onClick={onClose} aria-label="Fermer"><X size={18} /></button>
      </div>
      <p className="mb-3 text-[12.5px] text-slate-500">Cette fiche a plusieurs numéros : l'appel sera rattaché à la personne choisie.</p>
      <div className="space-y-1.5">
        {targets.map((t) => (
          <button key={t.key} data-testid={`pick-${t.key}`} onClick={() => onPick(t)}
            className="flex w-full items-center gap-3 rounded-xl border border-slate-200 px-3 py-2.5 text-left hover:border-emerald-300 hover:bg-emerald-50/40">
            {t.contact_id ? <UserRound size={16} className="shrink-0 text-indigo-500" /> : <Building2 size={16} className="shrink-0 text-slate-400" />}
            <span className="min-w-0 flex-1">
              <span className="block text-[13.5px] font-medium text-slate-900">{t.label}</span>
              {t.sub && <span className="block truncate text-xs text-slate-500">{t.sub}</span>}
            </span>
            <span className="font-mono text-[12.5px] text-slate-600">{t.number}</span>
            <PhoneCall size={14} className="shrink-0 text-emerald-700" />
          </button>
        ))}
      </div>
    </Modal>
  );
}
